export const YANDEX_VIDEOS_CONSTS = {
    addMoreMsg: 'Добавить ещё',
    addYandexVideoMsg: 'Добавить Яндекс видео',
    saveMsg: 'Сохранить',
    videoSettingsMsg: 'Настройки видео',
    yandexVideoDeletedMsg: 'Яндекс видео удалено',
    yandexVideoMsg: 'Яндекс видео',
    yandexVideoSavedMsg: 'Яндекс видео сохранено'
}
